<template>
  <div class="fixed inset-0 z-50">
    <div class="relative text-left">
      <div class="p-1 bg-gray-400 flex space-x-2 items-center">
        <div class="flex-1 text-white text-left flex items-center space-x-3">
          <div class="px-1 bg-gray-500 uppercase rounded-md text-sm">
            key
          </div>
          <div>{{ slug }}</div>
        </div>
        <div class="justify-end flex-shrink-0 flex space-x-2">
          <button class="py-1 px-4 bg-gray-600 rounded-lg text-white disabled:opacity-50" @click="get">
            Refresh
          </button>
          <button class="py-1 px-4 bg-blue-500 rounded-lg text-white disabled:opacity-50" @click="formatJson">
            Format
          </button>
          <button class="py-1 px-4 bg-primary-400 rounded-lg text-white disabled:opacity-50" @click="get_otp = true">
            Save
          </button>
          <button class="py-1 px-4 bg-gray-600 rounded-lg text-white disabled:opacity-50" @click="close">
            Close
          </button>
        </div>
      </div>
      <div v-if="error" class="p-2 text-red-500 bg-red-100">
        {{ error }}
      </div>
      <textarea
        ref="jsonEditor" v-model="json_str"
        class="w-full h-screen p-4 font-mono text-lg bg-gray-900 text-green-400 border-none outline-none resize-none"
        :style="{ height: 'calc(100vh - 60px)' }" spellcheck="false" autocomplete="off" autocorrect="off"
        autocapitalize="off" @blur="validate" @keydown="handleKeydown"
      />
    </div>
  </div>

  <Code2FA v-if="get_otp" :sending="sending" :error="error" @submit="save" @cancel="get_otp = false" />
</template>

<script>
import { API } from "@/api";
import { UTILS } from "@/utils";
import Code2FA from "@/components/Common/Code2FA";

export default {
  components: {
    Code2FA,
  },
  props: {
    slug: String,
  },
  emits: ["json-close"],
  data() {
    return {
      error: null,
      json_str: "",
      get_otp: false,
      sending: false,
    };
  },
  mounted() {
    this.get();
    // Focus the textarea after the component is mounted
    this.$nextTick(() => {
      if (this.$refs.jsonEditor) {
        this.$refs.jsonEditor.focus();
      }
    });
  },
  methods: {
    handleKeydown(event) {
      // Handle Tab key for indentation
      if (event.key === 'Tab') {
        event.preventDefault();
        const textarea = event.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        // Insert 2 spaces at cursor position
        const spaces = '  ';
        textarea.value = textarea.value.substring(0, start) + spaces + textarea.value.substring(end);
        textarea.selectionStart = textarea.selectionEnd = start + spaces.length;

        // Update v-model
        this.json_str = textarea.value;
      }

      // Handle Ctrl+S for save
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault();
        this.get_otp = true;
      }
    },
    formatJson() {
      try {
        const parsed = JSON.parse(this.json_str);
        this.json_str = JSON.stringify(parsed, null, 2);
        this.error = null;
      } catch (e) {
        this.error = "Cannot format invalid JSON";
      }
    },
    async save(otp) {
      this.sending = true;
      let page = this.validate();
      if (page === false) {
        this.$notify({
          group: "toast",
          type: "danger",
          title: "Alert",
          text: "The JSON has errors!",
        });
        return;
      }
      await API.put_page(UTILS._clone(page), otp);
      this.$notify({
        group: "toast",
        type: "success",
        title: "Success",
        text: "Page Saved!",
      })
        .catch((e) => {
          this.sending = false;

          // Handle errors based on error type and HTTP status code
          const status = e.response?.status;
          const errorCode = e.code;

          if (errorCode === "ERR_NETWORK" || e.message === "Network Error") {
            this.error = "Insecure Network";
          } else if (status === 400 || status === 422) {
            this.error = "Invalid Code";
          } else {
            this.error = "Unknown Error";
          }
        });
      this.close();
    },
    close() {
      this.$emit("json-close");
    },
    validate() {
      this.error = null;
      try {
        let json = JSON.parse(this.json_str);
        return json;
      } catch (e) {
        this.error = "JSON code has errors";
        return false;
      }
    },
    async get() {
      let resp = await API.page({ slug: this.slug });
      this.json_str = JSON.stringify(resp.data.data, null, 2);
    },
  },
};
</script>

<style></style>